<template>
  <div class="general-frame">
    <div class="general-neick" style="position: relative;">
      <!--1.搜索框按钮-->
      <div class="general-search-bar">
        <div
          class="customButton"
          v-for="(item,index) in dateQuery"
          :key="index"
          @click="timeSelection(index)"
          :class="butonStart === index ? 'border-end':''"
        >{{ item.name }}
        </div>
        <el-date-picker
          v-show="butonStart === 0"
          v-model="timeQuery.a"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="trigger()"
          @focus="timeQuery = {}"
        ></el-date-picker>
        <el-date-picker
          v-show=" butonStart === 1"
          v-model="timeQuery.b"
          type="week"
          format="yyyy 第 WW 周"
          value-format="yyyy-MM-dd"
          placeholder="请选择周数"
          :picker-options="pickerOptions"
          @change="trigger()"
          @focus="timeQuery = {}"
        ></el-date-picker>
        <el-date-picker
          v-show=" butonStart === 2"
          v-model="timeQuery.a"
          value-format="yyyy-MM-dd"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          @change="trigger()"
          @focus="timeQuery = {}"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-date-picker
          v-show="butonStart === 3"
          v-model="timeQuery.c"
          type="year"
          value-format="yyyy"
          placeholder="请选择年份"
          :picker-options="pickerOptions"
          @change="trigger()"
          @focus="timeQuery = {}"
        ></el-date-picker>
        <el-button
          style="margin-left: 10px;"
          type="primary"
          class="elm-but"
          :loading="loading"
          @click="eliminate"
        >重置
        </el-button>
      </div>
      <!--2.echarts及table图表-->
      <div style="margin: auto;">
        <!--echarts图表-->
        <div class="k_b1 flex-bottom" style="margin:0;height: 300px;">
          <bar-and-line :toilet="toiletDataList" :axisX="'toiletName'"></bar-and-line>
        </div>

        <!--table表格-->
        <table class="surface" style="margin-top:50px">
          <thead>
          <tr>
            <th>厕所名称</th>
            <th>人流量(人)</th>
            <th>用水量(吨)</th>
            <th>男女比例</th>
            <th>能耗(kw)</th>
            <th>状态</th>
            <th>巡检</th>
            <th>运维</th>
            <th>地区</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in  data" :key="index">
            <td>{{ item.name }}</td>
            <td>{{ item.sumPeo }}</td>
            <td>{{ item.sunWater.toFixed(3) }}</td>
            <td>
              {{
                "男" + (item.numM * 100 / (item.numM + item.numW) || 0).toFixed(0) + "% / 女"
                + (item.numW * 100 / (item.numM + item.numW) || 0).toFixed(0) + "%"
              }}
            </td>
            <td>{{ item.sumEle }}</td>
            <td>{{ "正常运行" }}</td>
            <td>{{ item.inspection }}</td>
            <td>{{ item.operation }}</td>
            <td>{{ "安吉" }}</td>
          </tr>
          </tbody>
          <noData :data="data"/>
        </table>
      </div>
    </div>
  </div>
</template>


<script>
import noData from "@/components/html/noData";
import barAndLine from "@/components/html/barAndLine.vue";

export default {
  components: {
    noData,
    barAndLine
  },
  data() {
    return {
      toiletDataList: [],
      dateQuery: [
        {name: "日"},
        {name: "周"},
        {name: "月"},
        {name: "年"},
      ],
      timeQuery: {
        a: [],
        b: "",
        c: "",
      },
      dasdasd: "",
      pageSize: 10, //每页10条
      pageNum: 1, //当前页码
      total: 0,
      data: null,
      startTime: null,
      butonStart: 0,
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如
        },
      },
    };
  },
  methods: {
    getList() {
      this.get("toiletInfo/list", {
        beginTime: this.beginTime,
        endTime: this.endTime,
        isQueryAll:false,
      }).then((res) => {
        this.data = res.data.rows;
        this.total = res.data.total;
      });
    },

    //厕所人流
    getToiletPeople() {
      this.get("toiletData/listCount", {
        beginTime: this.beginTime,
        endTime: this.endTime,
      })
      .then((res) => {
        this.toiletDataList = res.data.rows
      });
    },

    //时间选择
    timeSelection(index) {
      this.butonStart = index;
      this.timeQuery.a = [];
      this.timeQuery.b = "";
      this.timeQuery.c = "";
    },

    //重置
    eliminate() {
      this.timeQuery = {};
      this.beginTime = null;
      this.endTime = null;
      this.getList();
      this.getToiletPeople();
    },

    //日期查询
    trigger() {
      if (this.butonStart == 1) {
        var a = this.timeQuery.b;
        this.beginTime = a;
        var a = a.split("-");
        var nDate = new Date(a[1] + '-' + a[2] + '-' + a[0]); //转换为MM-DD-YYYY格式
        var millSeconds = Math.abs(nDate) + (6 * 24 * 60 * 60 * 1000);
        var rDate = new Date(millSeconds);
        var year = rDate.getFullYear();
        var month = rDate.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var date = rDate.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        this.endTime =year + "-" + month + "-" + date;
      } else if (this.butonStart == 2) {
        var a = this.timeQuery.a[1]
        var b = a.slice(6)
        var c = a.slice(0, a.length - 2);
        this.beginTime = this.timeQuery.a[0];
        this.endTime = c + new Date(new Date().getFullYear(), b.slice(0, b.length - 3), 0).getDate();
      } else if (this.butonStart == 3) {
        this.beginTime = this.timeQuery.c + "-01" + "-01";
        this.endTime = this.timeQuery.c + "-12" + "-31";
      } else {
        this.beginTime = this.timeQuery.a[0];
        this.endTime = this.timeQuery.a[1];
      }
      this.getList();
      this.getToiletPeople();
    },

    //pageNum  改变时会触发
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(); //调用终端数据接口
    },

    //pageSize改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },
  },
  mounted() {
    this.getList();
    this.getToiletPeople();
    // this.getCurrentTime();
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/menu/toilet/toiletAnalysis.vue